import {
    allFetch
} from "../Domain";

/**
 * @description PDI流程
 */
export const PDIProcedure = (() => {
    /**
     * @description 新增PDI流程 
     * @returns res
     */
    const PDIProcedureMasterCreate = async function (obj = {
        cs_id: '',
        note: ''
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterCreate', obj);
    }

    /**
     * @description 修改PDI流程 
     * @returns res
     */
    const PDIProcedureMasterUpdate = async function (obj = {
        pdi_pm_id: '',
        note: ''
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterUpdate', obj);
    }

    /**
     * @description 查詢PDI流程
     * @returns res
     */
    const PDIProcedureMasterSearch = async function (obj = {
        cs_id: '',
        procedure_audit_statuses: obj.procedure_audit_statuses === "" ? [] : obj.procedure_audit_statuses,
        procedure_submit_date_start: "",
        procedure_submit_date_end: "",
        finish_audit_statuses: obj.finish_audit_statuses === "" ? [] : obj.finish_audit_statuses,
        finish_submit_date_start: '',
        finish_submit_date_end: '',
        workstation_audit_statuses: obj.workstation_audit_statuses === "" ? [] : obj.workstation_audit_statuses,
        workstation_submit_date_start: '',
        workstation_submit_date_end: '',
        outer_order_number: "",
        car_type: '',
        FO: '',
        vin_no: '',
        predict_delivery_date_start: "",
        predict_delivery_date_end: "",
        contract_name: '',
        license_plate: '',
        custody_user_id: "",
        my_turn: "",
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterSearch', obj);
    }


    /**
     * @description 查詢PDI流程
     * @returns res
     */
    const PDIProcedureMasterSearchOwn = async function (obj = {
        cs_id: '',
        procedure_audit_statuses: obj.procedure_audit_statuses === "" ? [] : obj.procedure_audit_statuses,
        procedure_submit_date_start: "",
        procedure_submit_date_end: "",
        finish_audit_statuses: obj.finish_audit_statuses === "" ? [] : obj.finish_audit_statuses,
        finish_submit_date_start: '',
        finish_submit_date_end: '',
        car_type: '',
        FO: '',
        vin_no: '',
        contract_name: '',
        license_plate: '',
        custody_user_id: '',
        predict_delivery_date_start: '',
        predict_delivery_date_end: '',
        outer_order_number: '',
        note: '',
        my_turn: "",
        page: '',
        num_per_page: ''
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterSearchOwn', obj);
    }

    /**
     * @description PDI流程細項
     * @returns res
     */
    const PDIProcedureMasterDetail = async function (obj = {
        pdi_pm_id: ""
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterDetail', obj);
    }

    /**
     * @description PDI流程送審
     * @returns res
     */
    const PDIProcedureMasterSubmit = async function (obj = {
        pdi_pm_id: ""
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterSubmit', obj);
    }

    /**
     * @description PDI流程審核
     * @returns res
     */
    const PDIProcedureMasterAudit = async function (obj = {
        pdi_pm_id: '',
        status: '',
        note: ''
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterAudit', obj);
    }

    /**
     * @description PDI流程撤銷
     * @returns res
     */
    const PDIProcedureMasterCancel = async function (obj = {
        pdi_pm_id: ""
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterCancel', obj);
    }

    /**
     * @description PDI流程結案送審
     * @returns res
     */
    const PDIProcedureMasterFinalSubmit = async function (obj = {
        pdi_pm_id: ""
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterFinalSubmit', obj);
    }


    /**
     * @description PDI流程結案審核
     * @returns res
     */
    const PDIProcedureMasterFinalAudit = async function (obj = {
        pdi_pm_id: '',
        status: '',
        note: ''
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterFinalAudit', obj);
    }

    /**
     * @description 新增PDI流程工作站
     * @returns res
     */
    const PDIProcedureWorkstationCreate = async function (obj = {
        pdi_pm_id: '',
        pdi_ws_id: '',
        pdi_ws_name: '',
        appointment_time: '',
        note: '',
        seq: ""
    }) {
        return await allFetch('PDIProcedure/PDIProcedureWorkstationCreate', obj);
    }

    /**
     * @description 修改PDI流程工作站
     * @returns res
     */
    const PDIProcedureWorkstationUpdate = async function (obj = {
        pdi_pw_id: '',
        appointment_time: '',
        note: '',
        seq: ""
    }) {
        return await allFetch('PDIProcedure/PDIProcedureWorkstationUpdate', obj);
    }

    /**
     * @description 修改PDI流程工作站備註
     * @returns res
     */
    const PDIProcedureWorkstationUpdateNote = async function (obj = {
        pdi_pw_id: '',
        note: ''
    }) {
        return await allFetch('PDIProcedure/PDIProcedureWorkstationUpdateNote', obj);
    }


    /**
     * @description PDI流程工作站完成
     * @param {*} pdi_pw_id 施工流程工作站流水號
     * @returns res
     */
    const PDIProcedureWorkstationFinish = async function (obj = {
        pdi_pw_id: ''
    }) {
        return await allFetch('PDIProcedure/PDIProcedureWorkstationFinish', obj);
    }

    /**
     * @description 刪除PDI流程工作站
     * @returns res
     */
    const PDIProcedureWorkstationDelete = async function (obj = {
        pdi_pw_id: ''
    }) {
        return await allFetch('PDIProcedure/PDIProcedureWorkstationDelete', obj);
    }

    /**
     * @description PDI流程工作站總攬
     * @returns res
     */
    const PDIProcedureWorkstationOverview = async function (obj = {
        date_start: '',
        date_end: '',
        pdi_pw_id: '',
        pdi_ws_id: "",
        FO: "",
        vin_no: "",
        procedure_audit_statuses: [],
        finish_audit_statuses: [],
        custody_user_id: '',
    }) {
        return await allFetch('PDIProcedure/PDIProcedureWorkstationOverview', obj);
    }

    /**
     * @description pdi流程工作站查詢
     * @returns res
     */
    const PDIProcedureWorkstationSearch = async function (obj = {
        appointment_date_start: '',
        appointment_date_end: '',
        pdi_ws_id: ''
    }) {
        return await allFetch('PDIProcedure/PDIProcedureWorkstationSearch', obj);
    }

    /**
     * @description 新增PDI流程配件
     * @returns res
     */
    const PDIProdedureCarComponentCreate = async function (obj = {
        pdi_pm_id: '',
        stock_id: '',
        commodity_id: '',
        uc_id: '',
        ccad_id_1: '',
        ccad_id_2: '',
        need_calc_stock: '',
        price: '',
        count: '',
        final_price: '', // 成交價
        price_type: '', // 價格類型
        deductible_pay_price: '', // 自負金額
        company_pay_price: '', // 公司付金額
        headquarters_pay_price: '' // 總公司付金額
    }) {
        return await allFetch('PDIProcedure/PDIProdedureCarComponentCreate', obj);
    }

    /**
     * @description 修改PDI流程配件(數量跟$$而已)
     * @returns res
     */
    const PDIProdedureCarComponentUpdate = async function (obj = {
        pdi_pcc_id: '',
        price: '',
        count: '',
        final_price: '', // 成交價
        price_type: '', // 價格類型
        deductible_pay_price: '', // 自負金額
        company_pay_price: '', // 公司付金額
        headquarters_pay_price: '' // 總公司付金額
    }) {
        return await allFetch('PDIProcedure/PDIProdedureCarComponentUpdate', obj);
    }

    /**
     * @description 刪除PDI流程配件
     * @returns res
     */
    const PDIProdedureCarComponentDelete = async function (obj = {
        pdi_pcc_id: ''
    }) {
        return await allFetch('PDIProcedure/PDIProdedureCarComponentDelete', obj);
    }

    /**
     * 產生PDI給客人同意的token
     * @param {*} obj 
     * @returns 
     */
    const PDIProcedureMasterGenerateAgreeToken = async function (obj = {
        pdi_pm_id: ''
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterGenerateAgreeToken', obj);
    }

    /**
     * 驗證token 時效 查PDI流程資訊
     * @param {*} obj 
     * @returns 
     */
    const PDIProcedureMasterCheckToken = async function (obj = {
        token: ''
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterCheckToken', obj);
    }

    /**
     * 客人同意PDI內容
     * @param {*} obj 
     * @returns 
     */
    const PDIProcedureMasterCustomerAgree = async function (obj = {
        token: '',
        pdf_html: '',
        header_html: ''
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterCustomerAgree', obj);
    }

    /**
     * 取得PDI審核流程
     * @param {*} obj 
     * @returns 
     */
    const PDIProcedureMasterAuditProcess = async function (obj = {
        pdi_pm_id: ''
    }) {
        return await allFetch('PDIProcedure/PDIProcedureMasterAuditProcess', obj);
    }

    return {
        PDIProcedureMasterCreate,
        PDIProcedureMasterUpdate,
        PDIProcedureMasterSearch,
        PDIProcedureMasterSearchOwn,
        PDIProcedureMasterDetail,
        PDIProcedureMasterSubmit,
        PDIProcedureMasterAudit,
        PDIProcedureMasterCancel,
        PDIProcedureMasterFinalSubmit,
        PDIProcedureMasterFinalAudit,
        PDIProcedureWorkstationCreate,
        PDIProcedureWorkstationUpdate,
        PDIProcedureWorkstationUpdateNote,
        PDIProcedureWorkstationFinish,
        PDIProcedureWorkstationDelete,
        PDIProcedureWorkstationOverview,
        PDIProcedureWorkstationSearch,
        PDIProdedureCarComponentCreate,
        PDIProdedureCarComponentUpdate,
        PDIProdedureCarComponentDelete,
        PDIProcedureMasterGenerateAgreeToken,
        PDIProcedureMasterCheckToken,
        PDIProcedureMasterCustomerAgree,
        PDIProcedureMasterAuditProcess
    };
})()